<template>
  <modal :show="show" @change="$emit('change', $event)" width="400" :headerClass="currentLocale === 'ru' ? 'bg-main-orange white--text helvetica-roman fs-18' : 'bg-main-orange white--text rubik-medium fs-18'">
    <template v-slot:header>
      <span>{{$t('client')}}</span>
    </template>
    <template v-slot:main>
      <div  class="modal-info text-center mx-7 mb-2">
        <span class="d-block my-5 mb-9">
           {{$t('pages.changePassword.changeLogin').split('_')[0]}} {{newLogin}}{{$t('pages.changePassword.changeLogin').split('_')[1]}}
        </span>
        <v-btn @click="Close()" class="orange-button mb-2"
          >{{$t('buttons.close')}}
        </v-btn>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "../common/Modal";
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";

export default {
  name: "ModalNoElectricity",
  directives: {
    mask,
  },
  components: {
    Modal,
  },
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    newLogin:{
      type: String,
      default: "",
    }
  },
  data: () => ({
    message: "",
  }),
  computed: {
    ...mapGetters("locale",["currentLocale"]),
  },
  methods: {
    Close() {
      this.$emit("change");
    },
  },
};
</script>

<style lang="scss">
.modal-info {
  min-height: 200px;
  //display: flex;
  //flex-direction: column;

  &__message {
    margin: auto;
  }
}

.orange--checkbox {
  color: green !important;

  .accent--text {
    i {
      color: green !important;
    }
  }

  .v-application .accent--text {
    color: green !important;
  }
}

.modalPayment__form-item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  width: 100%;

  .modalPayment__form-checkbox {
    position: relative;
    height: max-content;
    padding: 5px 0 0 0;
  }

  .modalPayment__form-field {
    position: relative;
    width: calc(100% - 32px);
    height: max-content;
  }

  .commission {
    margin-left: 2110px;
    padding-left: 1000px;
  }
}
